import { Constantes } from "../constants/constantsGlobal";
import { paramChatbotRequest, paramChatbotResponse } from "../models/interfaceChatbotconversation";


export async function chatbotMessageRouter(
  params: paramChatbotRequest,
  files?: File[]
): Promise<any> {
  try {
    const formData = new FormData();
    if (files && files.length > 0) {
      params["attached_files"] = files.map(f => f.name);
      files.forEach(file => {
        formData.append(file.name, file);
      });
    } else {
      params["attached_files"] = [];
    }
    formData.append("data", JSON.stringify(params));

    const response = await fetch(Constantes.URI_ChatbotMessageRouter, {
      method: "POST",
      headers: {
        "token": Constantes.HEADER_CHAT_BOT_TOKEN,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Error enviando el mensaje a la API");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al enviar el mensaje:", error);
    throw error;
  }
}


